module.exports = __webpack_public_path__ + "img/code.6517361f.svg";